module.exports = __webpack_public_path__ + "static/media/logo.f4f34052.gif";